import {
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  Box
} from '@mui/material';
import { formatDistanceToNow } from 'date-fns';

/**
 * WeeklySummaryCards Component
 * Display weekly insights for patient (safe view)
 */

interface InsightCard {
  id: string;
  cardType: string;
  title: string;
  summary: string;
  confidence: number; // 0-1
  status: "NEW" | "VIEWED" | "RESOLVED";
  createdAt: string;
}

interface WeeklySummaryCardsProps {
  insights: InsightCard[];
}

export const WeeklySummaryCards: React.FC<WeeklySummaryCardsProps> = ({
  insights
}) => {
  return (
    <Grid container spacing={3}>
      {insights.map((insight) => (
        <Grid item xs={12} md={6} key={insight.id}>
          <Card elevation={2}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Chip
                  label={insight.cardType.replace(/_/g, ' ')}
                  size="small"
                  color="primary"
                />
                <Typography variant="caption" color="text.secondary">
                  {formatDistanceToNow(new Date(insight.createdAt), { addSuffix: true })}
                </Typography>
              </Box>

              <Typography variant="h6" gutterBottom>
                {insight.title}
              </Typography>

              <Typography variant="body2" color="text.secondary" paragraph>
                {insight.summary}
              </Typography>

              {insight.status === "NEW" && (
                <Chip label="New" size="small" color="success" />
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
